import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  nextButton: () => i18n.t(i18nKeys.inAppEducation__nextButton),
  moreQuestionsButton: () =>
    i18n.t(i18nKeys.inAppEducation__moreQuestionsButton),
  readyForFirstDashButton: () =>
    i18n.t(i18nKeys.inAppEducation__readyForFirstDeliveryButton),
  startDashing: {
    title: () => i18n.t(i18nKeys.inAppEducation__startDashing__title),
    description: () =>
      i18n.t(i18nKeys.inAppEducation__startDashing__description),
  },
  acceptOrders: {
    title: () => i18n.t(i18nKeys.inAppEducation__acceptOrders__title),
    description: () =>
      i18n.t(i18nKeys.inAppEducation__acceptOrders__description),
  },
  pickAndDropoff: {
    title: () => i18n.t(i18nKeys.inAppEducation__pickupAndDropoff__title),
    description: () =>
      i18n.t(i18nKeys.inAppEducation__pickupAndDropoff__description),
  },
  getPaid: {
    title: () => i18n.t(i18nKeys.inAppEducation__getPaid__title),
    description: () => i18n.t(i18nKeys.inAppEducation__getPaid__description),
  },
  support: {
    title: () => i18n.t(i18nKeys.inAppEducation__support__title),
    description: () => i18n.t(i18nKeys.inAppEducation__support__description),
  },
  readyToDash: {
    title: () => i18n.t(i18nKeys.inAppEducation__readyToDash__title),
  },
  talkToSpecialist: {
    confirmation: (phone: string) =>
      i18n.t(i18nKeys.talkToSpecialist__confirmation, { phone }),
    estimatedWait: (minutes: number) =>
      i18n.t(i18nKeys.talkToSpecialist__estimatedWait, { minutes }),
  },
}
